import React from "react";
import "./Home1.css";

const Home1 = () => {
  return (
    <div className="H1-div">
      <div className="main" style={{ paddingTop: "8rem" }}>
        <div
          className="H-heading"
          style={{ borderRight: "4px white solid", paddingRight: "20px" }}
        >
          <h2
            style={{ color: "white", textAlign: "end" }}
            className="heading12"
          >
            WE ARE <span style={{ fontWeight: "700" }}>THINKING</span> OF A NEW
            <br /> APPROACH TO YOUR CURRENT METHODS
          </h2>
        </div>
        <div
          className="H-para"
          style={{
            textAlign: "justify",
            color: "white",
            fontWeight: "200",
            paddingTop: "30px",
          }}
        >
          <p>
            Our top goal is to ensure that the requirements of our customers
            remain our top priority at all times throughout the process of
            integrating new features into our current services as we expand our
            service offerings.
          </p>
          <p>
            Consequently, we will be in a better position to react to the
            changing requirements of our customers and to provide them with
            better service in the future. Consequently, we consistently exceed
            our client's expectations by exceeding their needs, and we take care
            of any extra problems that occur on their behalf. Every aspect of
            our activity is overseen by a service sector organization, which is
            responsible for all aspects of our work. This organization is in
            charge of putting policies in place, executing programs, and
            assessing results on the field.
          </p>
          {/* <p>
            Consequently, we will be in a better position to react to the
            changing requirements of our customers and to provide them with
            better service in the future. Consequently, we consistently exceed
            our client's expectations by exceeding their needs, and we take care
            of any extra problems that occur on their behalf. Every aspect of
            our activity is overseen by a service sector organization, which is
            responsible for all aspects of our work. This organization is in
            charge of putting policies in place, executing programs, and
            assessing results on the field.
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default Home1;
